import { FilterFormFieldStrategyType } from "@/common/types";
import { diaInterfaceTechOptions } from "../filter-options";
import diaAccessTechOptions from "../filter-options/diaAccessTech.options";

const diaFormFilterByProduct: FilterFormFieldStrategyType[] = [
  {
    key: "BandWidth",
    element: {
      inputType: "range",
      label: "BandWidth",
      required: false,
      name: "DIA-bandWidth",
      rangeMax: 10000,
      rangeMin: 0,
    },
  },
  {
    key: "Access Technology",
    element: {
      inputType: "checkboxGroup",
      label: "Access Technology",
      required: false,
      name: "DIA-AccessTechnology",
      rangeMax: 10000,
      rangeMin: 0,
      options: diaAccessTechOptions,
    },
  },
  {
    key: "Interface",
    element: {
      inputType: "checkboxGroup",
      label: "Interface",
      name: "DIA-interface",
      required: false,
      options: diaInterfaceTechOptions,
    },
  },
];
export default diaFormFilterByProduct;
